import { useSelector } from 'react-redux';
import { CLOUDFLARE_SOFTBLOCK } from 'App/featuresFlags';
import { useHasTags } from 'App/hooks';
import { getNeedsCloudflareMigration } from '../../authSlice/authSelectors';

function useNeedsCloudflareMigration(): boolean {
  const [cloudflareBlockedFeatureEnabled] = useHasTags(CLOUDFLARE_SOFTBLOCK);
  const needsCloudflareMigration = useSelector(getNeedsCloudflareMigration);
  return cloudflareBlockedFeatureEnabled && needsCloudflareMigration;
}

export default useNeedsCloudflareMigration;
